import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';

import LdapConfig from 'workspaces/launcher/data/LdapConfig';

const Content: {
  ldapConfig: LdapConfig,
  complexPasswords: boolean,
  windowsEnable: boolean,
  aesaasLicense: boolean
} = {
  ldapConfig: new LdapConfig(),
  complexPasswords: false,
  windowsEnable: false,
  aesaasLicense: false
};

class IdentityProviders extends Immutable.Record(Content) {
  static fromJS (json: object): IdentityProviders {
    return ClassFactory.createFromJson(json, IdentityProviders);
  }
}

export default IdentityProviders;
